import React from "react";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
export const FloatingButton = ({ onClick, unreadCount = 0 }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      className="gpc-floating-button gpc-animate-fade-in"
      aria-label={t("chat.title")}
      title={t("chat.title")}
    >
      <MessageCircle className="gpc-floating-icon" />

      {unreadCount > 0 && (
        <span className="gpc-notification-badge">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </button>
  );
};